import clsx from "clsx";
import type React from "react";
import "./VisuallyHidden.css";

export type VisuallyHiddenProps<C extends React.ElementType = "span"> = {
  /** The element to render, e.g. `legend` or `caption` where the outline needs one. */
  as?: C;
} & Omit<React.ComponentPropsWithRef<C>, "as">;

/** Content for assistive technology only, such as a table caption or a group's legend. */
const VisuallyHidden = <C extends React.ElementType = "span">(props: VisuallyHiddenProps<C>) => {
  const { as, className, ...otherProps } = props;
  const Tag = as ?? "span";
  return <Tag className={clsx("calmlens-visually-hidden", className)} {...otherProps} />;
};

export default VisuallyHidden;
